import React from 'react';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="layout bg-slate-50 dark:bg-slate-950 dark:text-slate-100 min-h-screen">
      <main>{children}</main>
    </div>
  );
};

export default Layout;
export { Layout };
